export default __webpack_public_path__ + "search-examples-uitextfield-search-thumbnail-480-aeaf9fe5eb40f5d83609ae02b3fbc240.png";